(function () {
    //get the formApp module
    var formApp = angular.module('formApp');

    //set the controller to the code here - the controller uses DataServices.
    formApp.controller(
        'feedbackAssessmentFormController',
        ['$scope', '$http', '$controller', 'DataServices', 'UtilityServices', 'ValidationService', '$location', '$routeParams', '$rootScope', 'Constants',
            function ($scope, $http, $controller, DataServices, UtilityServices, ValidationService, $location, $routeParams, $rootScope, Constants) {

                // Inherit parent controller
                $controller('questionController', { $scope: $scope });
                $controller('followUpController', { $scope: $scope, feedbackType: Constants.FeedbackType.Complaint, incidentId: DataServices.responseInfo.incidentId });

                // only get the config data if we don't have it
                DataServices.getConfigurationUsingCache(Constants.ConfigTemplate.feedbackAssessment, $scope.versionNumber, null, DataServices.isAuthenticated())
                    .then(function (data) {
                        $scope.setupTriggersAndDynamicValues();
                        $scope.setSummaryErrorFocus();
                        $scope.isPageEditable = DataServices.isFollowUpEditable === true && $scope.page.isEditable === true;

                        document.title = $scope.utility.getPageTitle($scope.navTabNum, $scope.pageUrl);
                    });

                $scope.status = DataServices.responseInfo.status;
                $scope.incidentRef = DataServices.responseInfo.incidentRef;
                $scope.statusText = DataServices.responseInfo.statusText;
                $scope.template = Constants.ConfigTemplate.feedbackAssessment;

                //gets the program description
                $scope.getValueFromResponse = function (qCode) {
                    return DataServices.responseInfo.programDescription;
                }

                $scope.IsProgram = function (program) {
                    return DataServices.responseInfo.programDescription === program;
                }


                // Determine if we require the reason
                $scope.requireRecategorisationReason =
                    $scope.status === Constants.FollowUpStatus.submitted &&
                    $scope.notEmpty(null, 'faRecategorisationReason', 'assessment', 0, 0, '1-1');

                $scope.hasBeenRecategorised = function () {
                    return $scope.requireRecategorisationReason;
                }

                $scope.onCategoryChanged = function () {
                    // As long as the follow-up has been submitted, any change to the category
                    // requires the reason to be specified
                    $scope.requireRecategorisationReason = $scope.status === Constants.FollowUpStatus.submitted;
                }

                $scope.saveAssessment = function () {

                    $scope.currentLoadSubmitMessage = "Saving Feedback Assessment";

                    $scope.callSaveFollowUp($scope.feedbackType).then(function () {
                        // go back to co-ordination page
                        $scope.returnToCoordinationPage();
                    });
                }

                $scope.submitAssessment = function () {

                    if ($scope.validatePage($scope.navTabNum, $scope.pageUrl, null, null, null, 'inline')) {

                        $scope.currentLoadSubmitMessage = "Submitting Feedback Assessment";
                        $scope.callSubmitFollowUp($scope.feedbackType).then(function () {
                            $scope.returnToCoordinationPage();
                        });
                    }
                    else {
                        $scope.moveToFirstError();
                    }
                }

                $scope.cancel = function () {

                    $scope.callCancelFollowUp();
                }
            }]);
}());